const listTab = {
  System: 'System',
  Personal: 'Personal',
};
export const TABS = {
  ALERT_SYSTEM: 1,
  ALERT_PERSONAL: 2,
  ALERT_HISTORY: 3,
};
export default {
  listTab,
  pageSize: 50,
  TABS,
  idAlertSystem: 'notificationId',
  personalAlertCode: 'code',
  alertDefinitions: 'code',
  defaultOption: 'VolPriceIncrease',
};
